/**
 * Permission module and action constants from GET /api/me/permissions/
 */

export const PERMISSION_MODULES = {
  ACCOUNT: "account",
  CALENDAR: "calendar",
  DEFECTS: "defects",
  EVENTS: "events",
  INVENTORY: "inventory",
  MESSAGES: "messages",
  MOBILE_UNITS: "mobile_units",
  PATIENTS: "patients",
  REPORTS: "reports",
  SETTINGS: "settings",
  STAFFING: "staffing",
  TIMESHEET: "timesheet",
  USERS: "users",
  WORK_ORDERS: "work_orders",
};

/** Explicit API actions */
export const PERMISSION_ACTIONS = {
  VIEW: "view",
  VIEW_OWN: "view_own",
  CREATE: "create",
  EDIT: "edit",
  /** Aliases — both resolve to `edit` on the module */
  DELETE: "delete",
  DEACTIVATE: "deactivate",
};

/** Actions that are granted when the user has `{module}.edit` */
export const EDIT_IMPLIED_ACTIONS = new Set([
  PERMISSION_ACTIONS.DELETE,
  PERMISSION_ACTIONS.DEACTIVATE,
]);

/**
 * Build a codename like `mobile_units.view`
 * @param {string} module
 * @param {string} action
 */
export function toCodename(module, action) {
  return `${module}.${action}`;
}
